/** כסף מוצג כ "₪ 1,250": הסימן לפני המספר, רווח ביניהם (מערכת העיצוב). */
export function formatILS(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `₪ ${Math.round(value).toLocaleString('he-IL')}`;
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return value.toLocaleString('he-IL');
}

export function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return `${Math.round(value)}%`;
}
